interface Submission {
  id: number;
  eventposted: number;
  timesubmitted: number;
  page: string;
  siteid: string;
  returnaccess: string;
  returnurl: string;
  formlocation: string;
  title: string;
  numOfFields: number;
}

type CarrotFormsCookie = Record<string, Submission>;

/**
 * Get a cookie value by name.
 */
const get = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  // @ts-expect-error -- #todo type safely
  if (parts.length === 2) return parts.pop().split(';').shift();
};

/**
 * Set a cookie with the specified name, value and expiration (in days).
 */
const set = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};

/**
 * Parse submissions from the "oncarrot_forms" cookie.
 *
 * @returns {CarrotFormsCookie} An object representing the parsed submissions.
 */
const getSubmissions = (): CarrotFormsCookie => {
  const cookie = get('oncarrot_forms');
  if (!cookie) return {};

  // JSON.parse will throw bigly if the cookie is malformed.
  // So, try/catch will prevent cataclysm.
  try {
    return JSON.parse(decodeURIComponent(cookie));
  } catch (e: unknown) {
    console.error(e);
    return {};
  }
};

/**
 * Set submissions in the "oncarrot_forms" cookie.
 */
const setSubmissions = (submissions: CarrotFormsCookie) => {
  set('oncarrot_forms', JSON.stringify(submissions), 30);
};

export { getSubmissions, setSubmissions };
